export default __webpack_public_path__ + "static/spatiul-verde-0e89c394f998e2c9105eedf0d21c546c.jpg";